import {http} from "../config/Constantes";

export default class CentralService {
    constructor() {}

    list() {
        return http.get("/central");
    }

    listByPrefixoNome(nome) {
        return http.get(`/central/prefixo/${encodeURIComponent(nome)}`);
    }
}
